import { Route } from 'vue-router';
import Dashboard from '@/dashboard/Dashboard.vue';
import ClientDashboard from '@/account/client/ClientDashboard.vue';
import CompanyDashboard from '@/account/company/CompanyDashboard.vue';
import PricePlansPage from '@/price-plan/PricePlansPage.vue';

export default [
  {
    path: '',
    name: 'dashboard',
    component: Dashboard,
  },
  {
    path: 'accounts/:clientId/:tab?/:reportId?',
    name: 'client_dashboard',
    component: ClientDashboard,
    props(route: Route) {
      return {
        clientId: route.params.clientId,
        tab: route.params.tab,
        reportId: route.params.reportId,
      };
    },
  },
  {
    path: 'companies/:companyId/:tab?/:reportId?',
    name: 'company_dashboard',
    component: CompanyDashboard,
    props(route: Route) {
      return {
        companyId: route.params.companyId,
        tab: route.params.tab,
        reportId: route.params.reportId,
      };
    },
  },
  {
    path: 'price-levels',
    name: 'price_levels',
    component: PricePlansPage,
  },
];
